export default "__VITE_ASSET__Cdwl878Y__"